export default __webpack_public_path__ + "static/media/safeok.64ff186e.png";